module.exports = __webpack_public_path__ + "static/media/bed-moving-Icon-Rev-gre.a2645152.svg";